module.exports = __webpack_public_path__ + "img/276266378.4ce40983.jpg";